// extracted by mini-css-extract-plugin
export var footer = "_oj-5";
export var fulfillmentInput = "_oj-0";
export var shipDateInput = "_oj-1";
export var shipmentModal = "_oj-2";
export var shipmentModalContent = "_oj-3";
export var tableContainer = "_oj-4";